import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // GA4 page views are sent by enhanced measurement (page load + browser history changes),
    // so no manual gtag page_view here — sending one as well double-counts every page.
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);
}
